import React from 'react';
import { useHistory } from 'react-router-dom';

const pageContainer: React.CSSProperties = {
  minHeight: '100vh',
  backgroundColor: '#261136',
  padding: 24,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const shellCard: React.CSSProperties = {
  width: '100%',
  maxWidth: 900,
  background:
    'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  borderRadius: 16,
  padding: 24,
  boxSizing: 'border-box',
  boxShadow: '0 18px 45px rgba(0,0,0,0.45)',
  color: '#F5F5FA',
};

const headerRow: React.CSSProperties = {
  marginBottom: 16,
};

const titleStyle: React.CSSProperties = {
  fontSize: 22,
  fontWeight: 600,
};

const subtitleStyle: React.CSSProperties = {
  fontSize: 14,
  opacity: 0.8,
  marginTop: 4,
};

const sectionCard: React.CSSProperties = {
  backgroundColor: 'rgba(23, 8, 36, 0.9)',
  borderRadius: 12,
  padding: 16,
  border: '1px solid rgba(255,255,255,0.05)',
};

const listWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
};

const rowCard: React.CSSProperties = {
  backgroundColor: 'rgba(58, 31, 82, 0.9)',
  borderRadius: 10,
  padding: 12,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'transform 0.08s ease, box-shadow 0.08s ease',
} as React.CSSProperties;

const rowLeft: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

const rowTitle: React.CSSProperties = {
  fontSize: 15,
  fontWeight: 600,
};

const rowMeta: React.CSSProperties = {
  fontSize: 13,
  opacity: 0.9,
};

const caret: React.CSSProperties = {
  fontSize: 20,
  opacity: 0.7,
};

const TenantMenuPage: React.FC = () => {
  const history = useHistory();

  const handleHoverIn = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.transform = 'translateY(-1px)';
    e.currentTarget.style.boxShadow = '0 8px 18px rgba(0,0,0,0.35)';
  };

  const handleHoverOut = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = 'none';
  };

  return (
    <div style={pageContainer}>
      <div style={shellCard}>
        <div style={headerRow}>
          <h1 style={titleStyle}>Account &amp; settings</h1>
          <p style={subtitleStyle}>
            Manage your profile, billing, storage plan, and policies for your Bins account.
          </p>
        </div>

        <section style={sectionCard}>
          <div style={listWrapper}>
            <div
              style={rowCard}
              onClick={() => history.push('/tenant/account')}
              onMouseEnter={handleHoverIn}
              onMouseLeave={handleHoverOut}
            >
              <div style={rowLeft}>
                <div style={rowTitle}>Account information</div>
                <div style={rowMeta}>Name, email, phone, and address</div>
              </div>
              <div style={caret}>&gt;</div>
            </div>

            <div
              style={rowCard}
              onClick={() => history.push('/tenant/billing')}
              onMouseEnter={handleHoverIn}
              onMouseLeave={handleHoverOut}
            >
              <div style={rowLeft}>
                <div style={rowTitle}>Billing</div>
                <div style={rowMeta}>Payment method and receipts</div>
              </div>
              <div style={caret}>&gt;</div>
            </div>

            <div
              style={rowCard}
              onClick={() => history.push('/tenant/plan')}
              onMouseEnter={handleHoverIn}
              onMouseLeave={handleHoverOut}
            >
              <div style={rowLeft}>
                <div style={rowTitle}>Your storage plan</div>
                <div style={rowMeta}>Plan details and included bins</div>
              </div>
              <div style={caret}>&gt;</div>
            </div>

            <div
              style={rowCard}
              onClick={() => history.push('/tenant/terms')}
              onMouseEnter={handleHoverIn}
              onMouseLeave={handleHoverOut}
            >
              <div style={rowLeft}>
                <div style={rowTitle}>Terms &amp; Conditions</div>
                <div style={rowMeta}>Service terms and policies</div>
              </div>
              <div style={caret}>&gt;</div>
            </div>

            <div
              style={rowCard}
              onClick={() => history.push('/tenant/privacy')}
              onMouseEnter={handleHoverIn}
              onMouseLeave={handleHoverOut}
            >
              <div style={rowLeft}>
                <div style={rowTitle}>Privacy Policy</div>
                <div style={rowMeta}>How we handle your data</div>
              </div>
              <div style={caret}>&gt;</div>
            </div>

            <div
              style={rowCard}
              onClick={() => history.push('/tenant/faq')}
              onMouseEnter={handleHoverIn}
              onMouseLeave={handleHoverOut}
            >
              <div style={rowLeft}>
                <div style={rowTitle}>FAQ</div>
                <div style={rowMeta}>Common questions about Bins</div>
              </div>
              <div style={caret}>&gt;</div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TenantMenuPage;
